export const VERIFY_STATUS = {
    unbind: 1, // 没绑定过手机号，需要绑定
    hasSendCode: 2, // 已经发送验证码了
    cancel: 3,//取消按钮
};
